import React from "react";
import { Link } from "react-router-dom";

const Error = () => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <section className="gp404-section">
      <div className="gp404-bg-orb gp404-bg-orb-tl" />
      <div className="gp404-bg-orb gp404-bg-orb-br" />

      <div className="gp404-inner">
        <div className="gp404-eyebrow">
          <span className="gp404-eyebrow-dot" />
          PAGE NOT FOUND
        </div>

        <div className="gp404-number" aria-hidden="true">
          <span>4</span>
          <span className="gp404-number-zero">
            <svg viewBox="0 0 120 120" width="100%" height="100%" aria-hidden="true">
              <defs>
                <linearGradient id="gp404-grad" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#f1cf85" />
                  <stop offset="50%" stopColor="#d4a857" />
                  <stop offset="100%" stopColor="#b58a3f" />
                </linearGradient>
              </defs>
              <circle
                cx="60"
                cy="60"
                r="48"
                fill="none"
                stroke="url(#gp404-grad)"
                strokeWidth="14"
              />
            </svg>
          </span>
          <span>4</span>
        </div>

        <h1 className="gp404-title">
          Looks like this page <span className="gp404-title-accent">slipped away</span>
        </h1>

        <p className="gp404-sub">
          The page you're looking for doesn't exist, has been moved, or the link is no longer valid.
        </p>

        <div className="gp404-actions">
          <Link to="/home" onClick={ClickHandler} className="gp404-btn gp404-btn-primary">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M3 12l9-9 9 9" />
              <path d="M5 10v10a1 1 0 001 1h12a1 1 0 001-1V10" />
            </svg>
            <span>Back to Home</span>
          </Link>
          <Link to="/shop" onClick={ClickHandler} className="gp404-btn gp404-btn-ghost">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <circle cx="9" cy="21" r="1" />
              <circle cx="20" cy="21" r="1" />
              <path d="M1 1h4l2.7 13.4a2 2 0 002 1.6h9.7a2 2 0 002-1.6L23 6H6" />
            </svg>
            <span>Browse Gift Cards</span>
          </Link>
        </div>

        <div className="gp404-foot">
          Need help?{" "}
          <a
            href="https://wa.me/971545740174?text=Hi%20GlobalGiftPass%20support%2C%20I%20need%20help."
            target="_blank"
            rel="noreferrer"
            className="gp404-foot-link"
          >
            Chat with us on WhatsApp
          </a>
        </div>
      </div>

      <style>{`
        .gp404-section {
          position: relative;
          background: linear-gradient(180deg, #07060a 0%, #0b0b0c 60%, #0e0a05 100%);
          color: #e6e8ec;
          font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
          padding: 80px 24px 100px;
          overflow: hidden;
          min-height: 80vh;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .gp404-bg-orb {
          position: absolute;
          width: 480px;
          height: 480px;
          border-radius: 50%;
          filter: blur(140px);
          opacity: 0.4;
          pointer-events: none;
        }
        .gp404-bg-orb-tl { background: rgba(212,168,87,0.22); top: -180px; left: -160px; }
        .gp404-bg-orb-br { background: rgba(212,168,87,0.14); bottom: -200px; right: -160px; }

        .gp404-inner {
          position: relative;
          z-index: 1;
          max-width: 640px;
          width: 100%;
          text-align: center;
        }

        .gp404-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 6px 14px;
          background: rgba(212,168,87,0.1);
          border: 1px solid rgba(212,168,87,0.3);
          color: #d4a857;
          border-radius: 999px;
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 2px;
          margin-bottom: 22px;
        }
        .gp404-eyebrow-dot {
          width: 6px; height: 6px;
          border-radius: 50%;
          background: #d4a857;
          box-shadow: 0 0 10px #d4a857;
          animation: gp404-pulse 1.6s ease-in-out infinite;
        }
        @keyframes gp404-pulse {
          0%,100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.55; transform: scale(0.85); }
        }

        .gp404-number {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: clamp(96px, 18vw, 180px);
          font-weight: 700;
          line-height: 1;
          background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          margin-bottom: 22px;
          text-shadow: 0 12px 40px rgba(212, 168, 87, 0.18);
        }
        .gp404-number-zero {
          display: inline-flex;
          width: clamp(96px, 18vw, 180px);
          height: clamp(96px, 18vw, 180px);
          animation: gp404-spin 14s linear infinite;
        }
        @keyframes gp404-spin {
          to { transform: rotate(360deg); }
        }

        .gp404-title {
          font-family: "Playfair Display", "Times New Roman", serif;
          font-size: clamp(24px, 4vw, 34px);
          font-weight: 700;
          color: #fff;
          margin: 0 0 14px;
          line-height: 1.25;
          letter-spacing: -0.3px;
        }
        .gp404-title-accent {
          background: linear-gradient(135deg, #f1cf85, #b58a3f);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          font-style: italic;
          font-weight: 600;
        }

        .gp404-sub {
          font-size: 14.5px;
          color: #9aa0a8;
          line-height: 1.65;
          max-width: 460px;
          margin: 0 auto 30px;
        }

        .gp404-actions {
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 32px;
        }
        .gp404-btn {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          padding: 14px 24px;
          font-size: 13px;
          font-weight: 700;
          letter-spacing: 0.5px;
          text-transform: uppercase;
          border-radius: 12px;
          text-decoration: none;
          cursor: pointer;
          transition: transform .2s ease, box-shadow .25s ease, background .2s ease, border-color .2s ease, color .2s ease;
          min-height: 50px;
          min-width: 200px;
        }
        .gp404-btn-primary {
          background: linear-gradient(135deg, #f1cf85, #d4a857 50%, #b58a3f);
          color: #0b0b0c;
          border: 1px solid transparent;
        }
        .gp404-btn-primary:hover {
          transform: translateY(-2px);
          box-shadow: 0 14px 30px rgba(212,168,87,0.35);
          color: #0b0b0c;
          text-decoration: none;
        }
        .gp404-btn-ghost {
          background: rgba(255,255,255,0.02);
          color: #d4a857;
          border: 1px solid rgba(212,168,87,0.35);
        }
        .gp404-btn-ghost:hover {
          background: rgba(212,168,87,0.08);
          border-color: rgba(212,168,87,0.6);
          color: #f1cf85;
          transform: translateY(-2px);
          text-decoration: none;
        }

        .gp404-foot {
          padding-top: 24px;
          border-top: 1px dashed rgba(212,168,87,0.18);
          font-size: 13px;
          color: #9aa0a8;
        }
        .gp404-foot-link {
          color: #d4a857;
          font-weight: 700;
          text-decoration: none;
          transition: color .2s ease;
        }
        .gp404-foot-link:hover { color: #f1cf85; text-decoration: underline; }

        @media (max-width: 575px) {
          .gp404-section { padding: 60px 18px 80px; }
          .gp404-btn { min-width: 0; flex: 1; padding: 12px 16px; font-size: 12px; }
        }
      `}</style>
    </section>
  );
};

export default Error;
